import MainLayout from './SystemLayout'

export default MainLayout
